import React from 'react';

interface MobileSearchListProps {
    onItemClick: (value: string) => void;
    title: string;
    list: string[];
    extraItem?: React.ReactNode;
}

/**
 * Renders a generic list component used for displaying items like recently searched terms on mobile.
 * Includes a title, a list of clickable items, and an optional extra element (e.g., a "Clear History" button).
 */
export const MobileSearchList: React.FC<MobileSearchListProps> = ({
    onItemClick,
    title,
    list,
    extraItem,
}) => {
    return (
        <div className="px-6 md:px-0">
            <h3 className="text-base font-medium">{title}</h3>
            <ul className="my-4.5 space-y-2.5">
                {list.map((item, idx) => (
                    <li key={idx} className="w-auto text-left">
                        <button
                            type="button"
                            className="line-clamp-1 block min-h-4.5 max-w-full overflow-hidden truncate whitespace-nowrap text-left leading-[1.1] text-[#9b9b9b]"
                            onClick={() => onItemClick(item)}
                        >
                            {item}
                        </button>
                    </li>
                ))}
            </ul>
            {extraItem}
        </div>
    );
};
